"use strict";

var _regeneratorRuntime = require("/codebuild/output/src1368910246/src/jag-website/node_modules/@babel/runtime/regenerator/index.js");
var _slicedToArray = require("/codebuild/output/src1368910246/src/jag-website/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _objectWithoutProperties = require("/codebuild/output/src1368910246/src/jag-website/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _toConsumableArray = require("/codebuild/output/src1368910246/src/jag-website/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/codebuild/output/src1368910246/src/jag-website/node_modules/@babel/runtime/helpers/defineProperty.js");
var _excluded = ["extend"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var _marked = /*#__PURE__*/_regeneratorRuntime.mark(toPaths);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return resolveConfig;
  }
});
var _negateValue = /*#__PURE__*/_interopRequireDefault(require("./negateValue"));
var _corePluginList = /*#__PURE__*/_interopRequireDefault(require("../corePluginList"));
var _configurePlugins = /*#__PURE__*/_interopRequireDefault(require("./configurePlugins"));
var _defaultConfigStub = /*#__PURE__*/_interopRequireDefault(require("../../stubs/defaultConfig.stub"));
var _colors = /*#__PURE__*/_interopRequireDefault(require("../public/colors"));
var _defaults = require("./defaults");
var _toPath = require("./toPath");
var _normalizeConfig = require("./normalizeConfig");
var _isPlainObject = /*#__PURE__*/_interopRequireDefault(require("./isPlainObject"));
var _cloneDeep = require("./cloneDeep");
var _pluginUtils = require("./pluginUtils");
var _withAlphaVariable = require("./withAlphaVariable");
var _toColorValue = /*#__PURE__*/_interopRequireDefault(require("./toColorValue"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function isFunction(input) {
  return typeof input === "function";
}
function isObject(input) {
  return typeof input === "object" && input !== null;
}
function mergeWith(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  var customizer = sources.pop();
  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];
    for (var k in source) {
      var merged = customizer(target[k], source[k]);
      if (merged === undefined) {
        if (isObject(target[k]) && isObject(source[k])) {
          target[k] = mergeWith({}, target[k], source[k], customizer);
        } else {
          target[k] = source[k];
        }
      } else {
        target[k] = merged;
      }
    }
  }
  return target;
}
var configUtils = {
  colors: _colors.default,
  negative: function negative(scale) {
    // TODO: Log that this function isn't really needed anymore?
    return Object.keys(scale).filter(function (key) {
      return scale[key] !== "0";
    }).reduce(function (negativeScale, key) {
      var negativeValue = (0, _negateValue.default)(scale[key]);
      if (negativeValue !== undefined) {
        negativeScale["-".concat(key)] = negativeValue;
      }
      return negativeScale;
    }, {});
  },
  breakpoints: function breakpoints(screens) {
    return Object.keys(screens).filter(function (key) {
      return typeof screens[key] === "string";
    }).reduce(function (breakpoints, key) {
      return _objectSpread(_objectSpread({}, breakpoints), {}, _defineProperty({}, "screen-".concat(key), screens[key]));
    }, {});
  }
};
function value(valueToResolve) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return isFunction(valueToResolve) ? valueToResolve.apply(void 0, args) : valueToResolve;
}
function collectExtends(items) {
  return items.reduce(function (merged, _ref) {
    var extend = _ref.extend;
    return mergeWith(merged, extend, function (mergedValue, extendValue) {
      if (mergedValue === undefined) {
        return [extendValue];
      }
      if (Array.isArray(mergedValue)) {
        return [extendValue].concat(_toConsumableArray(mergedValue));
      }
      return [extendValue, mergedValue];
    });
  }, {});
}
function mergeThemes(themes) {
  return _objectSpread(_objectSpread({}, themes.reduce(function (merged, theme) {
    return (0, _defaults.defaults)(merged, theme);
  }, {})), {}, {
    // In order to resolve n config objects, we combine all of their `extend` properties
    // into arrays instead of objects so they aren't overridden.
    extend: collectExtends(themes)
  });
}
function mergeExtensionCustomizer(merged, value) {
  // When we have an array of objects, we do want to merge it
  if (Array.isArray(merged) && isObject(merged[0])) {
    return merged.concat(value);
  }
  // When the incoming value is an array, and the existing config is an object, prepend the existing object
  if (Array.isArray(value) && isObject(value[0]) && isObject(merged)) {
    return [merged].concat(_toConsumableArray(value));
  }
  // Override arrays (for example for font-families, box-shadows, ...)
  if (Array.isArray(value)) {
    return value;
  }
  // Execute default behaviour
  return undefined;
}
function mergeExtensions(_ref2) {
  var extend = _ref2.extend,
    theme = _objectWithoutProperties(_ref2, _excluded);
  return mergeWith(theme, extend, function (themeValue, extensions) {
    // The `extend` property is an array, so we need to check if it contains any functions
    if (!isFunction(themeValue) && !extensions.some(isFunction)) {
      return mergeWith.apply(void 0, [{}, themeValue].concat(_toConsumableArray(extensions), [mergeExtensionCustomizer]));
    }
    return function (resolveThemePath, utils) {
      return mergeWith.apply(void 0, [{}].concat(_toConsumableArray([themeValue].concat(_toConsumableArray(extensions)).map(function (e) {
        return value(e, resolveThemePath, utils);
      })), [mergeExtensionCustomizer]));
    };
  });
}
/**
 *
 * @param {string} key
 * @return {Iterable<string[] & {alpha: string | undefined}>}
 */
function toPaths(key) {
  var path, pattern, matches, _matches, prefix, alpha, newPath;
  return _regeneratorRuntime.wrap(function toPaths$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          path = (0, _toPath.toPath)(key);
          if (!(path.length === 0)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.next = 5;
          return path;
        case 5:
          if (!Array.isArray(key)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return");
        case 7:
          pattern = /^(.*?)\s*\/\s*([^/]+)$/;
          matches = key.match(pattern);
          if (!(matches !== null)) {
            _context.next = 15;
            break;
          }
          _matches = _slicedToArray(matches, 3), prefix = _matches[1], alpha = _matches[2];
          newPath = (0, _toPath.toPath)(prefix);
          newPath.alpha = alpha;
          _context.next = 15;
          return newPath;
        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
function resolveFunctionKeys(object) {
  // theme('colors.red.500 / 0.5') -> ['colors', 'red', '500 / 0', '5]
  var resolvePath = function resolvePath(key, defaultValue) {
    var _iterator = _createForOfIteratorHelper(toPaths(key)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var path = _step.value;
        var index = 0;
        var val = object;
        while (val !== undefined && val !== null && index < path.length) {
          val = val[path[index++]];
          var shouldResolveAsFn = isFunction(val) && (path.alpha === undefined || index <= path.length - 1);
          val = shouldResolveAsFn ? val(resolvePath, configUtils) : val;
        }
        if (val !== undefined) {
          if (path.alpha !== undefined) {
            var normalized = (0, _pluginUtils.parseColorFormat)(val);
            return (0, _withAlphaVariable.withAlphaValue)(normalized, path.alpha, (0, _toColorValue.default)(normalized));
          }
          if ((0, _isPlainObject.default)(val)) {
            return (0, _cloneDeep.cloneDeep)(val);
          }
          return val;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return defaultValue;
  };
  Object.assign(resolvePath, _objectSpread({
    theme: resolvePath
  }, configUtils));
  return Object.keys(object).reduce(function (resolved, key) {
    resolved[key] = isFunction(object[key]) ? object[key](resolvePath, configUtils) : object[key];
    return resolved;
  }, {});
}
function extractPluginConfigs(configs) {
  var allConfigs = [];
  configs.forEach(function (config) {
    allConfigs = [].concat(_toConsumableArray(allConfigs), [config]);
    var ref;
    var plugins = (ref = config === null || config === void 0 ? void 0 : config.plugins) !== null && ref !== void 0 ? ref : [];
    if (plugins.length === 0) {
      return;
    }
    plugins.forEach(function (plugin) {
      if (plugin.__isOptionsFunction) {
        plugin = plugin();
      }
      var ref;
      allConfigs = [].concat(_toConsumableArray(allConfigs), _toConsumableArray(extractPluginConfigs([(ref = plugin === null || plugin === void 0 ? void 0 : plugin.config) !== null && ref !== void 0 ? ref : {}])));
    });
  });
  return allConfigs;
}
function resolveCorePlugins(corePluginConfigs) {
  var result = _toConsumableArray(corePluginConfigs).reduceRight(function (resolved, corePluginConfig) {
    if (isFunction(corePluginConfig)) {
      return corePluginConfig({
        corePlugins: resolved
      });
    }
    return (0, _configurePlugins.default)(corePluginConfig, resolved);
  }, _corePluginList.default);
  return result;
}
function resolvePluginLists(pluginLists) {
  var result = _toConsumableArray(pluginLists).reduceRight(function (resolved, pluginList) {
    return [].concat(_toConsumableArray(resolved), _toConsumableArray(pluginList));
  }, []);
  return result;
}
function resolveConfig(configs) {
  var allConfigs = [].concat(_toConsumableArray(extractPluginConfigs(configs)), [{
    prefix: "",
    important: false,
    separator: ":",
    variantOrder: _defaultConfigStub.default.variantOrder
  }]);
  var ref, ref1;
  return (0, _normalizeConfig.normalizeConfig)((0, _defaults.defaults).apply(void 0, [{
    theme: resolveFunctionKeys(mergeExtensions(mergeThemes(allConfigs.map(function (t) {
      return (ref = t === null || t === void 0 ? void 0 : t.theme) !== null && ref !== void 0 ? ref : {};
    })))),
    corePlugins: resolveCorePlugins(allConfigs.map(function (c) {
      return c.corePlugins;
    })),
    plugins: resolvePluginLists(configs.map(function (c) {
      return (ref1 = c === null || c === void 0 ? void 0 : c.plugins) !== null && ref1 !== void 0 ? ref1 : [];
    }))
  }].concat(_toConsumableArray(allConfigs))));
}